<!-- ========== HEADER ========== -->
<header
  id="header"
  class="navbar navbar-expand-lg navbar-bordered navbar-spacer-y-0 flex-lg-column"
>
  <div class="navbar-light shadow w-100 bg-gradient bg-light py-2">
    <div class="container">
      <nav
        class="js-mega-menu navbar-nav-wrap hs-menu-initialized hs-menu-horizontal"
        style="direction: rtl"
      >
        <!-- Logo -->

        <a class="navbar-brand me-5 me-md-0" href="#" aria-label="Front">
          <img
            class="navbar-brand-logo"
            [src]="upFooterLogoPicSrc"
            alt="Logo"
            data-hs-theme-appearance="default"
          />
        </a>

        <!-- End Logo -->

        <!-- Secondary Content -->
        <div class="navbar-nav-wrap-secondary-content">
          <!-- Style Switcher -->
          <!-- Toggler -->
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarDoubleLineContainerNavDropdown"
            aria-controls="navbarDoubleLineContainerNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-default">
              <i class="bi-list"></i>
            </span>
            <span class="navbar-toggler-toggled">
              <i class="bi-x"></i>
            </span>
          </button>
          <!-- End Toggler -->

          <!-- End Style Switcher -->
        </div>
        <!-- End Secondary Content -->

        <!-- Collapse -->
        <div class="collapse navbar-collapse" id="navbarContainerNavDropdown">
          <ul class="navbar-nav"></ul>
        </div>
        <!-- End Collapse -->
      </nav>
    </div>
  </div>

  <div class="container-fluid bg-maroon">
    <nav
      class="js-mega-menu flex-grow-1 hs-menu-initialized hs-menu-horizontal"
    >
      <!-- Collapse -->
      <div
        class="collapse navbar-collapse"
        id="navbarDoubleLineContainerNavDropdown"
      >
        <ul
          class="navbar-nav navbar-dark bg-maroon justify-content-start"
          style="direction: rtl"
        >
          <!-- <li class="nav-item text-end">
                            <a class="hs-mega-menu-invoker nav-link" href="/site"><i class="bi-house dropdown-item-icon text-white-50"></i>الرئيسية </a>                    </li>
                       -->

          <li class="nav-item text-end" *ngIf="showExmp">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/ControlPanel/Exemptions"
              ><i class="bi-person dropdown-item-icon text-white-50"></i>
              الاعفائات</a
            >
          </li>

           <li class="nav-item text-end" *ngIf="showCommitteesAndDisabits">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/disability"
              ><i class="bi-person dropdown-item-icon text-white-50"></i>
              الاعاقات</a
            >
          </li>

           <li class="nav-item text-end" *ngIf="showCommitteesAndDisabits">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/committees"
              ><i class="bi-person dropdown-item-icon text-white-50"></i>
              اللجان الطبية</a
            >
          </li>

          <li class="nav-item text-end" *ngIf="showCommitteesAndDisabits">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/exam_dates"
              ><i class="bi-person dropdown-item-icon text-white-50"></i>
             مواعيد اللجان</a
            >
          </li>

          <!-- <li class="nav-item text-end">
                                <a class="hs-mega-menu-invoker nav-link" routerLink="/Investment/ControlPanel/Users"><i class="bi-person dropdown-item-icon text-white-50"></i> المستثمرين</a>
                            </li>

                            <li class="nav-item text-end">
                                <a class="hs-mega-menu-invoker nav-link" routerLink="/Investment/ControlPanel/Companies"><i class="bi-files-alt dropdown-item-icon text-white-50"></i> الشركات</a> </li>  -->

          <!-- <li class="nav-item me-2 text-end">
                                <a class="hs-mega-menu-invoker nav-link" href="/site/stats"><i class="bi-list dropdown-item-icon text-white-50"></i> الإحصائيات</a>                    </li>
                       
                                           
              
                                            <li class="nav-item me-2 text-end">
                            <a class="hs-mega-menu-invoker nav-link" href="/Investment/ControlPanel/FilterRequest"><i class="bi-window-stack dropdown-item-icon text-white-50"></i> جميع الطلبات</a>                    </li>
                            <li class="nav-item me-2 text-end">
                            <a class="hs-mega-menu-invoker nav-link" href="/Investment/ControlPanel/FilterRequest?finish=1"><i class="bi-door-closed dropdown-item-icon text-white-50"></i> الطلبات المنتهية</a>                    </li>
                                            
                                            <li class="nav-item me-2 text-end">
                            <a class="hs-mega-menu-invoker nav-link" href="/emp"><i class="bi-person dropdown-item-icon text-white-50"></i> الموظفون</a>                    </li> -->

          <li class="nav-item me-2 text-end" *ngIf="showFinance">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/ControlPanel/Recipt"
              ><i class="bi-cash dropdown-item-icon text-white-50"></i>
              المالية</a
            >
          </li>

          <li class="nav-item me-2 text-end" *ngIf="showFinance">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/ControlPanel/electronic-arrest-order"
              ><i class="bi-cash dropdown-item-icon text-white-50"></i> امر قبض
              الكتروني
            </a>
          </li>

          <li class="nav-item me-2 text-end" *ngIf="showFinance">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/ControlPanel/revenue-report"
              ><i class="bi-cash dropdown-item-icon text-white-50"></i> تقرير
              الإيرادات
            </a>
          </li>

          <li class="nav-item me-2 text-end" *ngIf="showEtewiSection">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/ControlPanel/manage-activity-license"
              ><i class="bi-cash dropdown-item-icon text-white-50"></i> 
                الرخص
            </a>
          </li>

          <li class="nav-item me-2 text-end" *ngIf="showEtewiSection">
            <a
              class="hs-mega-menu-invoker nav-link"
              routerLink="/{{mainPath}}/ControlPanel/manage-company"
              ><i class="bi-cash dropdown-item-icon text-white-50"></i> 
              الشركات
            </a>
          </li>


          <!-- <li class="nav-item me-2 text-end">
                            <a class="hs-mega-menu-invoker nav-link" href="/services"><i class="bi-list dropdown-item-icon text-white-50"></i> الخدمات</a>                    </li>
                                          -->
          <li class="nav-item me-2 text-end">
            <button
              type="button"
              (click)="logout()"
              class="hs-mega-menu-invoker nav-link bg-maroon border-0"
            >
              <i class="bi-box-arrow-left dropdown-item-icon text-white-50"></i>
              تسجيل خروج
            </button>
          </li>
          <!-- End Pages -->
        </ul>
      </div>
      <!-- End Collapse -->
    </nav>
  </div>
</header>
<!-- ========== END HEADER ========== -->
<!-- ========== MAIN CONTENT ========== -->

<router-outlet></router-outlet>

<footer class="container-fluid text-center bg-blue navbar-dark pt-5 pb-10" *ngIf="isProduction">
  <div class="row justify-content-center" >
      <div class="col-auto">
          <img [src]="downFooterLogoPicSrc" style="max-width: 180px;" class="img-fluid mb-2">
          <p class="text-white-50 text-end">
              {{'footer1'|translate}}    
          </p>
      </div>
  </div>
  <p class="mb-0 text-white-50">&#64; {{getYear()}} {{'footer2'|translate}}  {{'footer3'|translate}} </p>
</footer>
